<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>
                            Tra cứu, tìm kiếm tài liệu hướng dẫn sử dụng
                        </strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col offset-md="3">
                                <b-form-group label="Loại tài liệu:"
                                              label-for="manualType"
                                              :label-cols="4" label-cols-md="2"
                                              :horizontal="true"
                                              label-align="left">
                                    <treeselect placeholder="--- Tất cả ---"
                                                id="manualType"
                                                class="col-6 no-padding"
                                                v-if="listManualTypes.length > 0"
                                                v-model="searchForm.manualType"
                                                :options="listManualTypes" />
                                    <!--<select2 class="form-control"
                                    v-model="searchForm.syncType"
                                    :options="listSyncTypes" style="width:100%"></select2>-->
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="3">
                                <b-form-group label="Tên tài liệu:"
                                              label-for="sycnuser"
                                              :label-cols="4" label-cols-md="2"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" id="sycnuser" class="col-6" v-model="searchForm.name" placeholder="Nhập tên ..."></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="3">
                                <b-form-group label="" :label-cols="4" label-cols-md="2">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            dataUrl="master-data/user-manuals"
                            gridName="Danh sách tài liệu hướng dẫn sử dụng"
                            ref="userManualTable">
                        <template v-slot:actions v-if="authorize(['ManageUserManual'])">
                            <router-link to="./create" tag="button" class="btn btn-primary" size="md">
                                Thêm mới
                            </router-link>
                            <!--<b-button size="md" @click.stop="deletes" variant="danger" :disabled="isShowBtnDelete">
                                Xóa
                            </b-button>-->
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <b-button v-if="authorize(['ViewUserManual'])" size="sm" :to="{ path: `/help/user-manuals/${row.item.id}` }" title="xem" variant="info">
                                    Xem
                                </b-button>
                                <b-button v-if="authorize(['ManageUserManual'])" size="sm" @click.stop="remove(row.item, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                    Xoá
                                </b-button>
                            </b-button-group>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'
    export default {
        name: 'ListUserManuals',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    manualType: null,
                    name: null,
                },
                gridOptions: {
                    fields: [
                        { key: 'name', label: 'Tên tài liệu', sortable: true, sortDirection: 'asc' },
                        { key: 'manualTypeName', label: 'Loại tài liệu', sortable: false, },
                        { key: 'description', label: 'Mô tả', sortable: true, sortDirection: 'asc' },
                    ],
                    sortBy: 'createdDate',
                    sortDesc: true,
                },
                listManualTypes: [
                    { id: 1, label: 'Tài liệu hướng dẫn quản trị' },
                    { id: 2, label: 'Tài liệu hướng dẫn nghiệp vụ' },
                    { id: 3, label: 'Tài liệu hướng dẫn đồng bộ' }
                ],
                isShowBtnDelete: true
            }
        },
        computed: {
        },
        created() {
        },
        mounted() {
            this.$watch(
                () => {
                    return this.$refs.userManualTable.selectedRows
                },
                (val) => {
                    this.isShowBtnDelete = val.length == 0;
                }
            )
        },
        methods: {
            search() {
                this.$refs.userManualTable.refresh();
            },
            remove(item, index, button) {
                var vm = this;
                if (confirm('Bạn có chắc chắn muốn xóa tài liệu này?')) {
                    this.$services.delete(`master-data/user-manuals/${item.id}`).done(() => {
                        vm.$toastr.s('Xóa tài liệu thành công');
                        vm.search();
                    });
                }
            },
            deletes() {
                var vm = this;
                var selectedRows = this.$refs.userManualTable.selectedRows;
                if (selectedRows.length > 0) {
                    if (confirm('Bạn có chắc chắn muốn xóa các tài liệu này?')) {
                        var data = selectedRows.map(x => x.id).join(',');
                        this.$services.delete(`master-data/user-manuals?ids=${data}`).done(() => {
                            vm.$toastr.s('Xóa các tài liệu thành công');
                            vm.search();
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn tài liệu cần xóa');
                }
            }
        }
    }
</script>
<style scoped>
    .w30 {
        width: 30px;
    }
</style>
